import React, { useState } from "react";
import { InputField } from "../common/InputField";

// Fungsi untuk memformat tanggal ke format Indonesia
const formatDate = (dateString) => {
  if (!dateString) return "Date not yet determined";
  try {
    // Menangani format tanggal seperti "26/09/2025"
    const [day, month, year] = dateString.split("/");
    const date = new Date(`${year}-${month}-${day}`);
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }
    return "Date not yet determined";
  } catch {
    return "Date not yet determined";
  }
};

// Fungsi untuk memparse waktu untuk pengurutan
const parseTime = (time) => {
  const startTime = time ? time.split(" - ")[0] : "00:00";
  const [hours, minutes] = startTime.split(":").map(Number);
  return hours * 60 + minutes;
};

export const Rundown = ({ categoryName }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const trimmedCategoryName = categoryName ? categoryName.trim() : "";

  // Data rundown statis berdasarkan kategori
  const rundowns = {
    "MOUNTAIN UPHILL (5K)": [
      {
        date: "-",
        time: "-",
        activity: "Schedule will be updated soon",
        location: "-",
      },
    ],
    "MOUNTAIN CLASSIC (10K)": [
      {
        date: "-",
        time: "-",
        activity: "Schedule will be updated soon",
        location: "-",
      },
    ],
    "SHORT TRAIL (42K)": [
      {
        date: "-",
        time: "-",
        activity: "Schedule will be updated soon",
        location: "-",
      },
    ],
    "LONG TRAIL (75 K)": [
      {
        date: "-",
        time: "-",
        activity: "Schedule will be updated soon",
        location: "-",
      },
    ],
  };

  const rundownList = rundowns[trimmedCategoryName];

  // Jika categoryName tidak valid atau tidak ada rundown, tampilkan pesan
  if (!trimmedCategoryName || !rundownList || rundownList.length === 0) {
    return (
      <div className="px-4 py-4 text-sm text-gray-600 text-center">
        No rundown data available for category{" "}
        {trimmedCategoryName || "unknown"}.
      </div>
    );
  }

  // Filter berdasarkan searchQuery
  const filteredRundown = rundownList.filter((entry) =>
    Object.values(entry).some((value) =>
      value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  // Kelompokkan rundown berdasarkan tanggal
  const groupedRundown = filteredRundown.reduce((acc, entry) => {
    const formattedDate = formatDate(entry.date);
    acc[formattedDate] = acc[formattedDate] || [];
    acc[formattedDate].push(entry);
    return acc;
  }, {});

  // Urutkan entri berdasarkan waktu
  Object.keys(groupedRundown).forEach((date) => {
    groupedRundown[date].sort((a, b) => parseTime(a.time) - parseTime(b.time));
  });

  return (
    <div>
      <div className="flex justify-end mb-4 px-4 pt-4">
        <div className="w-full max-w-xs">
          <InputField
            name="search"
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search rundown..."
            labelColor="text-lime-800"
          />
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full table-auto divide-y divide-slate-200">
          <thead>
            <tr className="bg-gray-100 divide-x divide-slate-200">
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Date
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Time
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Activity
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Location
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {Object.keys(groupedRundown).length > 0 ? (
              Object.entries(groupedRundown).map(([date, entries], groupIdx) =>
                entries.map((entry, idx) => {
                  const isCutOff = entry.activity.includes("Cut Off Time");
                  const isFlagOff = entry.activity.includes("Flag Off");
                  const isDate28 = entry.date === "28/09/2025";
                  const rowColor = isFlagOff
                    ? "text-lime-600"
                    : isCutOff
                    ? "text-red-600"
                    : "text-gray-600";
                  return (
                    <tr
                      key={`${groupIdx}-${idx}`}
                      className={`border-b border-slate-200 last:border-b-0 transition-colors duration-200 hover:bg-gray-50 ${rowColor} divide-x divide-slate-200`}
                    >
                      <td
                        className={`px-4 py-4 text-sm text-left ${
                          isCutOff && isDate28 ? "text-gray-600" : rowColor
                        }`}
                      >
                        {idx === 0 ? date : ""}
                      </td>
                      <td className="px-4 py-4 text-sm text-left">
                        {entry.time || "-"}
                      </td>
                      <td className="px-4 py-4 text-sm text-left">
                        {entry.activity || "-"}
                      </td>
                      <td className="px-4 py-4 text-sm text-left">
                        {entry.location || "-"}
                      </td>
                    </tr>
                  );
                })
              )
            ) : (
              <tr>
                <td
                  colSpan="4"
                  className="px-4 py-4 text-sm text-gray-600 text-center"
                >
                  No rundown data available for category{" "}
                  {trimmedCategoryName}.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
